import { useState, useCallback, useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL

const COLOR_CATEGORIA = {
  cotidiano: '#3B82F6', trabajo: '#059669', viajes: '#F59E0B', preguntas: '#8B5CF6'
}
const NOMBRE_CATEGORIA = {
  cotidiano: 'Cotidiano', trabajo: 'Trabajo', viajes: 'Viajes', preguntas: 'Preguntas'
}

function barajar(array) {
  const copia = [...array]
  for (let i = copia.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[copia[i], copia[j]] = [copia[j], copia[i]]
  }
  return copia
}

/* Juego de Ordena la Frase: se muestran las palabras de una
   oracion en ingles desordenadas y el usuario hace clic en ellas
   en el orden correcto para reconstruir la oracion. Al terminar
   las 8 oraciones puede reclamar XP. Se puede jugar tantas veces
   como se quiera. */
export default function OrdenaFraseJuego({ usuario, onCambio }) {
  const [cargando,   setCargando]   = useState(true)
  const [oraciones,  setOraciones]  = useState([])
  const [indice,     setIndice]     = useState(0)
  const [fichas,     setFichas]     = useState([])   // [{ id, texto, usada }]
  const [colocadas,  setColocadas]  = useState([])   // array de ids en orden
  const [validado,   setValidado]   = useState(false)
  const [esCorrecta, setEsCorrecta] = useState(false)
  const [aciertos,   setAciertos]   = useState(0)
  const [terminado,  setTerminado]  = useState(false)
  const [enviando,   setEnviando]   = useState(false)
  const [resultado,  setResultado]  = useState(null)
  const [error,      setError]      = useState(null)

  const nuevaPartida = useCallback(() => {
    setCargando(true)
    setError(null)
    setIndice(0)
    setColocadas([])
    setValidado(false)
    setAciertos(0)
    setTerminado(false)
    setResultado(null)
    axios.get(`${API}/juegos/ordena-frase?cantidad=8`).then(res => {
      const datos = res.data.datos || []
      setOraciones(datos)
      if (datos.length) prepararFichas(datos[0])
    }).catch(err => {
      console.error('Error cargando ordena la frase:', err)
      setError('No pudimos cargar las oraciones. Intenta de nuevo.')
    }).finally(() => setCargando(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function prepararFichas(oracionObj) {
    const palabras = oracionObj.oracion.split(' ')
    const nuevasFichas = palabras.map((texto, i) => ({ id: i, texto, usada: false }))
    setFichas(barajar(nuevasFichas))
    setColocadas([])
    setValidado(false)
  }

  useEffect(() => { nuevaPartida() }, [nuevaPartida])

  function colocarFicha(id) {
    if (validado) return
    setFichas(prev => prev.map(f => f.id === id ? { ...f, usada: true } : f))
    setColocadas(prev => {
      const nuevas = [...prev, id]
      const p = oraciones[indice]
      if (nuevas.length === p.oracion.split(' ').length) {
        verificar(nuevas)
      }
      return nuevas
    })
  }

  function quitarUltima() {
    if (validado || !colocadas.length) return
    const ultimo = colocadas[colocadas.length - 1]
    setColocadas(prev => prev.slice(0, -1))
    setFichas(prev => prev.map(f => f.id === ultimo ? { ...f, usada: false } : f))
  }

  function verificar(idsColocados) {
    const p = oraciones[indice]
    const palabrasOriginales = p.oracion.split(' ')
    const respuestaTexto = idsColocados.map(id => palabrasOriginales[id]).join(' ')
    const correcta = respuestaTexto === p.oracion
    setEsCorrecta(correcta)
    setValidado(true)
    if (correcta) setAciertos(a => a + 1)

    setTimeout(() => {
      if (indice < oraciones.length - 1) {
        const siguienteIndice = indice + 1
        setIndice(siguienteIndice)
        prepararFichas(oraciones[siguienteIndice])
      } else {
        setTerminado(true)
      }
    }, 1800)
  }

  async function reclamarXp() {
    if (enviando || !usuario?.id) return
    setEnviando(true)
    setError(null)
    try {
      const res = await axios.post(`${API}/juegos/ordena-frase/completar`, {
        usuario_id: usuario.id, aciertos, total_oraciones: oraciones.length
      })
      setResultado(res.data)
      if (onCambio) onCambio()
    } catch (err) {
      console.error('Error guardando resultado de ordena la frase:', err)
      setError('No pudimos guardar tu resultado. Intenta de nuevo.')
    } finally {
      setEnviando(false)
    }
  }

  if (cargando) {
    return (
      <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--gris-texto)' }}>
        Cargando oraciones...
      </div>
    )
  }

  if (!oraciones.length) {
    return (
      <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--gris-texto)' }}>
        <div style={{ fontSize: 44, marginBottom: 12 }}>📝</div>
        <p>Todavía no hay oraciones cargadas. ¡Vuelve pronto!</p>
      </div>
    )
  }

  return (
    <div style={{ animation: 'fadeIn .3s ease both', maxWidth: 640 }}>
      <div style={{ marginBottom: 22 }}>
        <h1 style={{ fontSize: 24, fontWeight: 800 }}>📝 Ordena la Frase</h1>
        <p style={{ color: 'var(--gris-texto)', fontSize: 14, marginTop: 4 }}>
          Organiza las palabras para formar una oración correcta en inglés.
        </p>
      </div>

      {error && (
        <div style={{ background: '#FEE2E2', color: '#B91C1C', borderRadius: 10, padding: '10px 14px', fontSize: 13, marginBottom: 16 }}>
          {error}
        </div>
      )}

      {!terminado && (() => {
        const p = oraciones[indice]
        const color = COLOR_CATEGORIA[p.categoria] || 'var(--azul)'
        return (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
              <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--azul)' }}>Oración {indice + 1} de {oraciones.length}</span>
              <div style={{ flex: 1, height: 6, background: 'var(--gris-borde)', borderRadius: 999, overflow: 'hidden' }}>
                <div style={{ width: `${(indice / oraciones.length) * 100}%`, height: '100%', background: 'var(--dorado)', borderRadius: 999, transition: 'width .3s ease' }} />
              </div>
              <span style={{ fontSize: 12, fontWeight: 700, color: '#F59E0B' }}>✓ {aciertos}</span>
            </div>

            <div style={{ background: '#fff', border: '1px solid var(--gris-borde)', borderRadius: 18, padding: 24 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
                <span style={{ background: color, color: '#fff', fontSize: 11, fontWeight: 800, padding: '3px 10px', borderRadius: 999 }}>
                  {NOMBRE_CATEGORIA[p.categoria] || p.categoria}
                </span>
                <span style={{ fontSize: 11, color: 'var(--gris-texto)' }}>{p.nivel}</span>
              </div>

              {p.traduccion && (
                <div style={{ background: '#F8FAFF', borderRadius: 10, padding: 12, marginBottom: 18 }}>
                  <p style={{ fontSize: 12.5, color: 'var(--gris-texto)' }}>💡 {p.traduccion}</p>
                </div>
              )}

              <div style={{
                minHeight: 56, border: '1.5px dashed var(--gris-borde)', borderRadius: 12, padding: 12,
                display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', marginBottom: 16,
                background: validado ? (esCorrecta ? '#DCFCE7' : '#FEE2E2') : '#F8FAFF'
              }}>
                {colocadas.length === 0 && (
                  <span style={{ fontSize: 12.5, color: 'var(--gris-texto)' }}>Toca las palabras en orden...</span>
                )}
                {colocadas.map((id, pos) => {
                  const ficha = fichas.find(f => f.id === id)
                  return (
                    <button key={pos} onClick={() => pos === colocadas.length - 1 && quitarUltima()}
                      disabled={validado}
                      style={{
                        padding: '8px 12px', borderRadius: 8, border: '1.5px solid var(--azul)',
                        background: '#fff', color: '#1A1A2E', fontFamily: 'inherit', fontSize: 13.5, fontWeight: 700,
                        cursor: (!validado && pos === colocadas.length - 1) ? 'pointer' : 'default'
                      }}>
                      {ficha ? ficha.texto : ''}
                    </button>
                  )
                })}
              </div>

              {!validado && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {fichas.filter(f => !f.usada).map(f => (
                    <button key={f.id} onClick={() => colocarFicha(f.id)}
                      style={{
                        padding: '8px 12px', borderRadius: 8, border: '1.5px solid var(--gris-borde)',
                        background: '#fff', color: '#1A1A2E', fontFamily: 'inherit', fontSize: 13.5, fontWeight: 700,
                        cursor: 'pointer'
                      }}>
                      {f.texto}
                    </button>
                  ))}
                </div>
              )}

              {validado && !esCorrecta && (
                <div style={{ background: '#F8FAFF', borderRadius: 10, padding: 12, marginTop: 4 }}>
                  <p style={{ fontSize: 12.5, color: 'var(--gris-texto)' }}>
                    La oración correcta era: <strong>{p.oracion}</strong>
                  </p>
                </div>
              )}
            </div>
          </div>
        )
      })()}

      {terminado && (
        <div style={{ background: '#fff', border: '1px solid var(--gris-borde)', borderRadius: 18, padding: 26, textAlign: 'center' }}>
          <div style={{ fontSize: 44, marginBottom: 10 }}>{aciertos >= oraciones.length * 0.7 ? '🎉' : '💪'}</div>
          <h2 style={{ fontSize: 19, fontWeight: 800, marginBottom: 6 }}>¡Partida terminada!</h2>
          <p style={{ fontSize: 14, color: 'var(--gris-texto)', marginBottom: 20 }}>
            Armaste {aciertos} de {oraciones.length} oraciones correctamente.
          </p>

          {resultado ? (
            <div>
              <div style={{ background: 'linear-gradient(135deg,#065F46,#059669)', color: '#fff', borderRadius: 14, padding: 18, marginBottom: 18 }}>
                <div style={{ fontSize: 20, fontWeight: 800 }}>+{resultado.xp_ganado} XP ganados</div>
              </div>
              <button onClick={nuevaPartida}
                style={{ width: '100%', padding: '13px', borderRadius: 12, border: 'none', background: 'var(--azul)', color: '#fff',
                  fontFamily: 'inherit', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
                🔁 Jugar de nuevo
              </button>
            </div>
          ) : (
            <button onClick={reclamarXp} disabled={enviando}
              style={{ width: '100%', padding: '14px', borderRadius: 12, border: 'none', fontFamily: 'inherit',
                fontSize: 15, fontWeight: 700, cursor: enviando ? 'not-allowed' : 'pointer',
                background: enviando ? '#CBD5E1' : 'var(--dorado)', color: '#fff' }}>
              {enviando ? 'Guardando...' : `Reclamar +${aciertos * 3} XP`}
            </button>
          )}
        </div>
      )}
    </div>
  )
}
